import { Fragment, MouseEvent } from "react"

import { Badge } from "../../../../ui"
import CopyTextButton from "../../../copy-text-button"
import { LeadRatesNowBadge } from "../../lead-rates-now-badge"
import { useInMobileView } from "../../../../hooks"
import {
  DEFAULT_DATETIME_LONG_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import { LeadLog } from "../../../../../types"

type Props = {
  info: LeadLog
  onClick: (event: MouseEvent<HTMLDivElement>) => void
}

const LeadsCell = ({ info, onClick }: Props) => {
  const {
    name = "Unnamed",
    email,
    resthook_status,
    timestamp,
    owner_email,
    source
  } = info
  const inMobileView = useInMobileView()

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer"
      colSpan={inMobileView ? 2 : 1}
    >
      {inMobileView ? (
        <Fragment>
          <div className="text-sm text-gray-400 pb-4">
            {formatDateTimeFromTimestamp(
              timestamp,
              DEFAULT_DATETIME_LONG_FORMAT
            )}
          </div>
          <div className="flex flex-col">
            <div className="flex items-center">
              <div className="font-bold break-words">{email}</div>
              <CopyTextButton text={email} ariaLabel="Copy email" />
            </div>
            <div className="flex items-center">
              <span
                className="text-sm text-gray-400 mr-2 hover:border-b border-neutral-500 leading-none"
                onClick={onClick}
              >
                {name}
              </span>
              {resthook_status && <Badge.Info>{resthook_status}</Badge.Info>}
              <LeadRatesNowBadge source={source} />
            </div>
            <div className="text-sm pt-1">by {owner_email}</div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="flex items-center gap-2">
            <div
              className="font-bold hover:border-b border-neutral-500 leading-none"
              onClick={onClick}
            >
              {name}
            </div>
            {resthook_status && <Badge.Info>{resthook_status}</Badge.Info>}
            <LeadRatesNowBadge source={source} />
          </div>
          <div className="flex items-center">
            <div className="text-neutral-400 text-sm">{email}</div>
            <CopyTextButton text={email} ariaLabel="Copy email" />
          </div>
        </Fragment>
      )}
    </td>
  )
}

export default LeadsCell
